export const NewClientGetters = {
  GetNewClient: 'getNewClient',
  GetNewClientAddressList: 'getNewClientAddressList'
};
export const NewClientMutations = {
  UpdateNewClientDetails: 'updateNewClientDetails',
  ResetNewClientDetails: 'resetNewClientDetails',
  AddNewClientAddress: 'addNewClientAddress',
  UpdateNewClientAddress: 'updateNewClientAddress',
  UpdateNewClientDefaultAddress: 'updateNewClientDefaultAddress'
};
export const NewClientActions = {
  UpdateNewClientDetails: 'updateNewClientDetails',
  ResetNewClientDetails: 'resetNewClientDetails',
  AddNewClientAddress: 'addNewClientAddress',
  UpdateNewClientAddress: 'updateNewClientAddress',
  UpdateNewClientDefaultAddress: 'updateNewClientDefaultAddress',
  SaveNewClientDetails: 'saveNewClientDetails',
  UpdateClientDefaultAddress: 'updateClientDefaultAddress'
};
